<template>
    <div>
        <div class="pt-6">
            <div v-if="isTreasurehunt">
                <div
                    v-for="element in content"
                    :key="element._id"
                    class="columns"
                >
                    <session-detail-clue
                        v-if="element.type == 'clue'"
                        :question="element"
                        :user-answer="answerForQuestion(element)"
                        :correct-answers-count="correctAnswersCount(element)"
                        :incorrect-answers-count="
                            incorrectAnswersCount(element)
                        "
                        :assistance="assistanceForClue(element)"
                        class="column is-12 question-detail"
                    />
                    <session-detail-question
                        v-else
                        :question="element"
                        :user-answer="answerForQuestion(element)"
                        :correct-answers-count="correctAnswersCount(element)"
                        :incorrect-answers-count="
                            incorrectAnswersCount(element)
                        "
                        class="column is-12 question-detail"
                    />
                </div>
            </div>
            <div v-else>
                <session-detail-question
                    v-for="question in questions"
                    :key="question._id"
                    :question="question"
                    :user-answer="answerForQuestion(question)"
                    :correct-answers-count="correctAnswersCount(question)"
                    :incorrect-answers-count="incorrectAnswersCount(question)"
                    class="question-detail"
                />
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'underscore';
import SessionDetailQuestion from '@/components/SessionDetailQuestion';
import SessionDetailClue from '@/components/SessionDetailClue';
export default {
    components: {
        SessionDetailQuestion,
        SessionDetailClue,
    },
    props: {
        questions: {
            type: Array,
            default: () => {
                return [];
            },
        },
        userAnswers: {
            type: Array,
            default: () => {
                return [];
            },
        },
        isTreasurehunt: {
            type: Boolean,
            default: false,
        },
        content: {
            type: Array,
            default: () => {
                return [];
            },
        },
    },
    data() {
        return {};
    },
    methods: {
        answerForQuestion(question) {
            const score = _.find(this.userAnswers, (answer) => {
                return answer.object == question._id;
            });
            return score ? score.answer.value : [];
        },
        correctAnswersCount(question) {
            return _.filter(question.scores, (score) => {
                return score.points > 0;
            }).length;
        },
        incorrectAnswersCount(question) {
            return _.filter(question.scores, (score) => {
                return score.points <= 0;
            }).length;
        },
        assistanceForClue(clue) {
            let assistance = {
                compass: 0,
                distance: 0,
                nothing: 0,
                all: 0,
            };
            for (const score of clue.scores) {
                if (score.assistance) {
                    // console.log('assistance found', score.assistance);
                    if (score.assistance.compass) {
                        // console.log('compass found', score.assistance);
                        assistance.compass = assistance.compass + 1;
                    }
                    if (score.assistance.distance) {
                        assistance.distance = assistance.distance + 1;
                    }
                    if (score.assistance.compass && score.assistance.distance) {
                        assistance.all = assistance.all + 1;
                    }
                    if (
                        !score.assistance.compass &&
                        !score.assistance.distance
                    ) {
                        assistance.nothing = assistance.nothing + 1;
                    }
                } else {
                    assistance.nothing = assistance.nothing + 1;
                }
            }
            return assistance;
        },
    },
    mounted() {
        // console.log(this.content);
        // console.log("is treasurehunt?",this.isTreasurehunt)
    },
};
</script>

<style></style>
